import React, { useState, useContext, FormEvent } from "react";
import { observer } from "mobx-react-lite";
import { Button, Form, Input, Select } from "semantic-ui-react";
import { IWarehouseLog } from "../../../app/models/warehouselog";
import TransmissionStore from "../../../app/stores/transmissionStore";
const MaterialEditForm: React.FC = () => {
  const transmissionStore = useContext(TransmissionStore);
  const {
    warehouseRegistry,
    warehousesByName,
    selectedWarehouselog,
    editWarehouselog,
    submitting,
    cancelFormOpen,
  } = transmissionStore;

  const [warehouselog, setWarehouselog] = useState<IWarehouseLog>(
    selectedWarehouselog!
  );

  const warehouseOptions = warehousesByName.map((warehouse) => {
    var option = {
      key: warehouse.id,
      text: warehouse.name,
      value: warehouse.id,
    };
    return option;
  });

  const handleSubmit = () => {
    editWarehouselog(warehouselog);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setWarehouselog({ ...warehouselog, [name]: value });
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Input
            label="Serial Number"
            onChange={handleInputChange}
            name="partNo"
            placeholder="Serial Number"
            value={warehouselog.partNo}
          />
          <Form.Select
            label="Material Name"
            name="name"
            search
            //value={warehouselog.name}
            onChange={(e, { value }) => {
              const warehouse = warehouseRegistry.get(value);
              setWarehouselog({
                ...warehouselog,
                name: warehouse.name,
                stock: Number(warehouse.stock),
                partNo: warehouse.partNo,
              });
            }}
            options={warehouseOptions}
            
          />
          <Form.Input
            label="Quantity"
            onChange={handleInputChange}
            name="quantity"
            placeholder="Quantity"
            value={warehouselog.quantity}
          />
        </Form.Group>

        <Button
          loading={submitting}
          positive
          floated="right"
          type="submit"
          content="Submit"
        />
        <Button
          onClick={cancelFormOpen}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </div>
  );
};

export default observer(MaterialEditForm);
